import { createMetricDistanceUnitPort, distanceUnits, } from "./distance-unit";
import { createView2DPresentation, } from "../2d-views/view-2d-presentation";
// Percent and Ratio is related with only slope's.
export var SlopeTextRender;
(function (SlopeTextRender) {
    SlopeTextRender["PERCENT"] = "percent";
    SlopeTextRender["RATIO"] = "ratio";
    SlopeTextRender["DEGREE"] = "degree";
})(SlopeTextRender || (SlopeTextRender = {}));
export { distanceUnits, createMetricDistanceUnitPort };
const distanceUnitLabelMap = {
    METERS: "m",
    FEET: "ft",
    US_SURVEY_FEET: "ft",
};
export const getDistanceUnitLabel = (unit) => {
    return distanceUnitLabelMap[unit];
};
export class ViewerSettings {
    _createDistanceUnitPort;
    _distanceUnitPort;
    _presentation;
    _longitudeSlopTextRenderType;
    constructor(createDistanceUnitPort = createMetricDistanceUnitPort) {
        this._createDistanceUnitPort = createDistanceUnitPort;
        this._distanceUnitPort = createDistanceUnitPort(distanceUnits.METERS);
        this._presentation = createView2DPresentation(this._distanceUnitPort);
        this._longitudeSlopTextRenderType = SlopeTextRender.RATIO;
    }
    get longtiudeSlopeTextRenderType() {
        return this._longitudeSlopTextRenderType;
    }
    set longtiudeSlopeTextRenderType(type) {
        this._longitudeSlopTextRenderType = type;
    }
    get distanceUnitPort() {
        return this._distanceUnitPort;
    }
    get viewerUnitType() {
        return this._distanceUnitPort.unit;
    }
    get presentation() {
        return this._presentation;
    }
    set viewerUnitType(type) {
        this._distanceUnitPort = this._createDistanceUnitPort(type);
        this._presentation = createView2DPresentation(this._distanceUnitPort);
    }
}
//# sourceMappingURL=viewer-settings.js.map